import React, { Ref } from "react";
import classNames from "classnames";

import { StrainRelatives } from "custom-types/StrainV2";

import StrainLineageLink from "./StrainLineageLink";

type Props = {
  child1Ref: Ref<HTMLDivElement>;
  child2Ref: Ref<HTMLDivElement>;
  children: StrainRelatives;
  parentalClassExtension: "no-parents" | "two-parents" | "single-parent";
};

const StrainLineageTwoChildren = ({
  child1Ref,
  child2Ref,
  children,
  parentalClassExtension,
}: Props) => (
  <>
    <div
      className={classNames("w-[80px]", {
        "col-[1/3] row-[4/6]": parentalClassExtension === "no-parents",
        "col-[1/3] row-[7/9]": parentalClassExtension === "single-parent",
        "col-[2/3] row-[6/8]": parentalClassExtension === "two-parents",
      })}
      ref={child1Ref}
    >
      <StrainLineageLink
        strain={children[0]}
        altText="First strain child"
        parentOrChild="child"
      />
    </div>
    <div
      className={classNames("w-[80px]", {
        "col-[5/6] row-[6/8]": parentalClassExtension === "two-parents",
        "col-[5/7] row-[4/6]": parentalClassExtension === "no-parents",
        "col-[5/7] row-[7/9]": parentalClassExtension === "single-parent",
      })}
      ref={child2Ref}
    >
      <StrainLineageLink
        strain={children[1]}
        altText="Second strain child"
        parentOrChild="child"
      />
    </div>
  </>
);

export default StrainLineageTwoChildren;
